import { render } from "./PlayoffBracketBlock.vue?vue&type=template&id=267808c6&scoped=true"
import script from "./PlayoffBracketBlock.vue?vue&type=script&lang=js"
export * from "./PlayoffBracketBlock.vue?vue&type=script&lang=js"

import "./PlayoffBracketBlock.vue?vue&type=style&index=0&id=267808c6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267808c6"]])

export default __exports__